import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ScorePanel from '../score-panel';
import { getChartColors } from '../../../../utils/chartTheme';

const getScoreColor = score => {
  if (score < 0) return '#E74C3C';
  if (score <= 50) return '#FFBB28';
  if (score <= 75) return '#ece637';
  return '#00C49F';
};

// data: [{ Name, Value }] na ordem Detrator, Neutro, Promotor
// (mesma ordem devolvida por GET /api/calledclassifications/chart/query/nps)
// Score = %Promotor - %Detrator (fórmula clássica de NPS)
const NpsTable = memo(function NpsTable(props) {
  const { data, intl } = props;
  const colors = getChartColors();

  const values = (data || []).map(item => item.Value || item.value || 0);
  const [detratorCount, neutroCount, promotorCount] = values;
  const total = values.reduce((sum, value) => sum + (value || 0), 0);
  const detratorPercent = total > 0 ? (detratorCount / total) * 100 : 0;
  const promotorPercent = total > 0 ? (promotorCount / total) * 100 : 0;
  const score = Math.round(promotorPercent - detratorPercent);

  const rows = [
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.nps.detractor', defaultMessage: 'Detrator' }), color: '#db324d', value: detratorCount || 0 },
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.nps.neutral', defaultMessage: 'Neutro' }), color: '#ffe234', value: neutroCount || 0 },
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.nps.promoter', defaultMessage: 'Promotor' }), color: '#00C49F', value: promotorCount || 0 },
  ];

  return (
    <ScorePanel
      id="agent-productivity-nps"
      title={intl.formatMessage({ id: 'agentproductivity.dashboard.nps.title', defaultMessage: 'NPS (transacional por chamado)' })}
      resultLabel={intl.formatMessage({ id: 'agentproductivity.dashboard.nps.result', defaultMessage: 'Resultado NPS' })}
      scoreLabel={intl.formatMessage({ id: 'agentproductivity.dashboard.nps.score', defaultMessage: 'NPS SCORE' })}
      scoreValue={score}
      scoreColor={getScoreColor(score)}
      rows={rows}
      icon={<ThumbUpAltIcon />}
      accentColor={colors.info}
      tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.nps.tooltip', defaultMessage: 'NPS (Net Promoter Score) mede a probabilidade de recomendação — calculado como % de Promotores menos % de Detratores nas avaliações do período.' })}
    />
  );
});

export default injectIntl(NpsTable);
